module.exports = __webpack_public_path__ + "assets/49006737dbeb0af0087b66c20239454d.png";